export default __webpack_public_path__ + "static/media/address.62537a2c.svg";